import { get } from 'lodash';

export const widgetsByIdSelector = state => get( state, 'widgets.byId', {} );
export const isExportingGridToCsvSelector = ( state, props ) => get( state, 'widgets.isExporting', [] ).includes( props.config.id );

